import React from 'react';
import { Languages } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import content from '../../i18n/content';
import './LanguageToggle.css';

const LanguageToggle = () => {
  const { lang, toggleLanguage } = useLanguage();
  const t = content[lang];

  return (
    <button
      className="language-toggle"
      onClick={toggleLanguage}
      aria-label={t.nav.langToggleLabel}
      title={t.nav.langToggleLabel}
      type="button"
    >
      <span className="language-toggle-icon">
        <Languages size={18} />
      </span>
      <span className="language-toggle-label">{t.nav.langToggle}</span>
    </button>
  );
};

export default LanguageToggle;
